import { ConfirmModal } from '@sparklayer-io/spark-dash-ui/components/confirm-modal';
import { t } from 'i18next';
import { useHandlers } from '../../../../context/page-context';
import { useAPISettingsDelete } from '../../hooks/use-api-settings-keys-delete';

export function DeleteConfirmationModal({
  keyData,
  isOpen,
  closeModal,
}: {
  keyData: { name: string; clientId: string } | null;
  isOpen: boolean;
  closeModal: () => void;
}) {
  const { notificationHandler } = useHandlers();

  const {
    mutate: deleteKey,
    reset: deleteReset,
    isPending: deletePending,
  } = useAPISettingsDelete();

  if (!keyData) {
    return null;
  }

  const handleDelete = () => {
    deleteReset();
    deleteKey(keyData.clientId, {
      onSuccess: () => {
        notificationHandler.notify(
          t('notifications:titles.success'),
          t('notifications:deleted'),
          'success',
        );
      },
      onError: () => {
        notificationHandler.notify(t('notifications:titles.error'), t('errors:generic'), 'error');
      },
    });
    closeModal();
  };

  return (
    <ConfirmModal
      isOpen={isOpen}
      onClose={closeModal}
      onConfirm={handleDelete}
      loading={deletePending}
      title={t('features:api_settings.components.modals.delete_confirm.header', {
        keyName: keyData.name,
      })}
      confirmText={t('features:api_settings.components.modals.delete_confirm.delete')}
      message={t('features:api_settings.components.modals.delete_confirm.body', {
        keyName: keyData.name,
      })}
    />
  );
}
